module.exports = __webpack_public_path__ + "public/images/slider/speaker-6-icon.e2144af13202d5280be07ff5d75abc42.png";